<template>
  <b-modal
    id="sharetoclient"
    centered
    hide-footer
    :visible="showShareToClient"
    hide-header
    no-close-on-backdrop
    @hidden="closeShareModal()"
  >
    <div class="d-flex align-items-center justify-content-between">
      <div class="teams-modal-head">
        {{ candidate.pushed ? "Re-Share " : "Share " }}to Client
      </div>

      <div @click="closeShareModal()">
        <img
          src="../../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt
          class="pointer rotate-on-hover"
        />
      </div>
    </div>
    <hr />
    <div class="sharetoclient-modal-desc">
      The Candidates will be shared to client
    </div>
    <div
      class="schedint-panelist-info-container d-flex align-items-center mt-3"
    >
      <div class="w-10 text-center">
        <div
          v-if="
            candidate.customFields &&
            candidate.customFields.imageMedia &&
            candidate.customFields.imageMedia != null
          "
          class="kanban-maincard-dp"
        >
          <img
            class="w-100 h-100"
            :src="candidate.customFields.imageMedia"
            alt=""
          />
        </div>
        <div
          class="
            kanban-maincard-dp-text
            d-flex
            justify-content-center
            align-items-center
          "
          v-else
        >
          {{ candidate.name[0].toUpperCase() }}
        </div>
      </div>
      <div class="w-40">{{ candidate.name }}</div>
      <div class="w-50 text-truncate">{{ candidate.email }}</div>

      <!-- <div
        @click="$emit('view-candidate')"
        class="w-10 ml-2 text-center pointer"
      >
        <img src="../../../assets/img/newkanban/tabview.svg" alt />
      </div> -->
    </div>
    <div class="w-100 position-relative my-4">
      <hr />
      <div class="vk-ortxt">OR</div>
    </div>
    <div class="common-single-checkbox">
      <b-form-checkbox v-model="selectrec"
        >Select particular recruiter</b-form-checkbox
      >
    </div>
    <!-- <div class="sharetoclient-modal-desc">Select recruiter to push the selected candidates</div> -->
    <div v-if="selectrec" class="mt-3">
      <div class="stc-label">
        Recruiters
        <span class="asterik">*</span>
      </div>
      <div class="relativeclass">
        <div
          ref="opendrop"
          @click="showrecoptions = !showrecoptions"
          class="acs-filter-dropdown mt-1 position-relative pointer"
        >
          <span class="newManage-dropdown-place">{{
            selected ? projectUsers[selected].username : "Select"
          }}</span>

          <img
            src="../../../assets/img/accessconnew/blueDownArrowSmall.svg"
            alt
          />
        </div>
        <div
          ref="predefineddrop"
          v-closable="{
            exclude: ['predefineddrop', 'opendrop'],
            handler: 'hideRecDrop',
          }"
          v-if="showrecoptions"
          class="newInt-radio-dropdown p-0"
          style="top: 36px"
        >
          <b-form-group class="sec-mcq-datacard">
            <b-form-radio-group
              class="
                blueColor
                newInt-radio-dropdown-inner-content
                w-100
                relativeclass
              "
              size="sm"
              value-field="userID"
              text-field="username"
              v-model="selected"
              :options="options"
              @change="showrecoptions = !showrecoptions"
              buttons
              stacked
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </div>
    </div>
    <div
      class="
        d-flex
        align-items-center
        justify-content-end
        p-2
        bluebtn
        mt-2
        mb-2
      "
    >
      <b-button
        class="acs-cancelBtn-modal w-105px mr-3"
        @click="closeShareModal()"
        >Cancel</b-button
      >
      <div class="position-relative">
        <b-button
          class="acs-addBtn-modal w-95px"
          @click="pushCandidatesForRecruitment"
          :disabled="!disabledPush"
          :class="
            LoaderStatus ? 'upload-loader-class defaultCursor' : 'pointer'
          "
          >{{ LoaderStatus ? "" : "Share" }}</b-button
        >
        <div v-if="LoaderStatus" class="upload-loader-pos">
          <Loader />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { pushCandidates } from "../../../utils/apiFunctions";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import toast from "../../mixin/toast";

export default {
  name: "ShareToClient",
  props: {
    showShareToClient: Boolean,
    candidate: Object,
    particularJob: Object,
    shareType: Boolean,
  },
  components: {
    Loader,
  },
  mixins: [toast],
  data() {
    return {
      LoaderStatus: false,
      selected: "",
      selectrec: false,
      options: [],
      showrecoptions: false,
    };
  },
  created() {
    let current = this.particularJob.vendor.find(
      (obj) => obj.vendorID == this.$route.params.vendorID
    );
    let assgnedIds = current.taggedRecruiters;
    let optionVal = [];
    for (let i of assgnedIds) {
      let value = this.projectUsers[i];
      optionVal.push(value);
    }
    this.options = optionVal;
  },
  watch: {
    selectrec(val) {
      if (val == false) {
        this.selected = "";
      }
    },
  },
  computed: {
    ...mapGetters("userVUEX", {
      projectUsers: "getProjectUsers",
    }),
    disabledPush() {
      if (this.selectrec) {
        return this.selected != "";
      } else {
        return true;
      }
    },
  },
  methods: {
    hideRecDrop() {
      this.showrecoptions = false;
    },
    closeShareModal() {
      this.$emit("closesharemodal");
    },
    async pushCandidatesForRecruitment() {
      this.LoaderStatus = true;
      let payload = {
        random: false,
        recruiterUserID: !this.selectrec
          ? this.particularJob.createdBy
          : this.selected,
        candidateIDs: [this.candidate.candidateID],
        jobID: this.particularJob.jobID,
        vendorID: this.$route.params.vendorID,
        reShare: this.shareType,
      };
      if (this.candidate.kanbanStatus == "Not Interested") {
        payload.inLevel = "NI";
      }

      // push candidates pass fail api
      let res = await pushCandidates(payload);

      if (res.status == 200) {
        this.LoaderStatus = false;

        this.$emit("sharesuccess");
        this.closeShareModal();
        this.$nextTick(() => {
          this.dynamicToast(
            "pushed",
            `Successfully pushed`,
            `Candidate "${this.candidate.name}" has been successfully pushed`
          );
        });
      } else {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
      }
    },
  },
};
</script>

<style scoped>
.upload-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 95px;
}

.upload-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 0px;
}
</style>
